import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import _ from 'lodash';
import template from './NewInstallationOverlay.rt';
import {getFilteredFeatureGroups} from './../../../ProjectScope/ProjectScopeSelector';
import {getFilteredPendingFeatureGroups} from './../../../ProjectScope/NewFeatureGroup/NewFeatureGroupSelector';
import {getActiveInstallationGroup} from './../../InstallationSelector';
import {getActiveEditData} from './NewInstallationGroupItemSelector';
import * as NIOActions from './NewInstallationGroupItemActions';
import * as actions from '../../../../actions';
import * as uuid from 'uuid';

export const PRODUCT_SORT_OPTIONS = {
  Price: "Price",
  Name: "Name"
};

export const SCREENS = {
  Assignment: 0,
  Gallery: 1
}

const MapStateToProps = (state) => {
  const edit = getActiveEditData(state);
  const featureGroups = getFilteredFeatureGroups(state);
  const pendingFeatureGroups = getFilteredPendingFeatureGroups(state);
  const allFeatureGroups = _.sortBy(_.union(featureGroups, pendingFeatureGroups),
    a => _.trim(a.name).toLowerCase())
    .filter(g => g.features && g.features.length > 0 && g.enabled);
  const installationGroup = getActiveInstallationGroup(state);

  return {
    group: state.newInstallationGroupItem.group,
    featureGroups: allFeatureGroups,
    units: state.newInstallationGroup.installationUnits,
    filterGroups: state.newInstallationGroup.filterGroups,
    installationGroup,
    installation: edit
  };
}

const MapDispatchToProps = (dispatch, props) => {
  return {
    showLoadingDialog: (show, title, text) => dispatch(actions.loadingDialog_show(show, title, text)),
    showNewInstallationGroupItemOverlay: (show) => dispatch(NIOActions.showNewInstallationGroupItemOverlay(props.group, show)),
    save: (data) => dispatch(NIOActions.saveNewInstallationGroupItem(data))
  };
}

class NewInstallationOverlayClass extends PureComponent {
  constructor(props) {
    super(props);

    //#region binding protections
    this.handleCancel = this.handleCancel.bind(this);
    //#endregion

    let unitList = _.map(props.units, u => { return {text: u.unit, value: u}; });
    let edit = props.installation || {};
    let unit = props.units && props.units.length > 0 ? props.units[0] : null;

    if(edit.installationUnit_id) {
      unit = _.find(props.units, u => u.id === edit.installationUnit_id);
    }
    let activeGroup = null;
    if(edit.assignedFeatures && edit.assignedFeatures.length > 0) {
      var hasFeatures = {};
      props.featureGroups.forEach(fg => {
        let len = fg.features.filter(f => f.fabricatorData && edit.assignedFeatures.includes(f.fabricatorData.fabFeat_id)).length;
        if(len > 0) {
          hasFeatures[len] = fg.name;
        }
      });
      var _k = 0;
      var activeGroupName = null;
      for(var k in hasFeatures) {
        if(k > _k) {
          _k = k;
          activeGroupName = hasFeatures[k];
        }
      }
      if(activeGroupName) {
        activeGroup = _.find(props.featureGroups, fg => fg.name === activeGroupName);
      }
    }
    this.state = {
      id: edit.id || -1,
      activeGroup,
      installationGroup: props.installationGroup,
      name: edit.name || '',
      description: edit.description || '',
      forQuotingTool: edit.forQuotingTool || false,
      forVisualizers: edit.forVisualizers || '',
      hideUnitLabel: edit.hideUnitLabel || false,
      automaticAdd: edit.automaticAdd || false,
      customerAdd: edit.customerAdd || false,
      employeeOnly: edit.employeesOnly || false,
      hideQuantity: edit.hideQuantity || false,
      defaultQuantity: edit.defaultQuantity || 1,
      features: edit.assignedFeatures || [],
      unit: unit,
      unitList,
      newUnits: [],
      productFilter: '',
      productSortBy: PRODUCT_SORT_OPTIONS.Name,
      sortOptionsVisible: false,
      selectedFilters: [],
      expandedFilters: [],
      colorFilterOptionsVisible: false,
      materialFilterOptionsVisible: false,
      allFilterOptionsVisible: false,
      materialFilterOptions: [],
      colorFilterOptions: [],
      allFilterOptions: [],
      screen: SCREENS.Assignment,
      thumbnailImage: null,
      thumbnailImageUrl: edit.thumbnailImageUrl || null,
      galleryEnabled: edit.galleryEnabled || false,
      galleryImages: edit.gallery || [],
      nameError: '',
      descError: '',
      thumbError: '',
      checkAllFeatures: false
    };
  };

  allProductsClicked = () => {
    var checkAllFeatures = !this.state.checkAllFeatures;
    var features = [...this.state.features];
    var visibleProducts = this.applyProductSort(this.applyProductFilters(this.getGroupsFeatures(this.state.activeGroup)));
    _.each(visibleProducts, p => {
      let index = p.fabricatorData ? features.indexOf(p.fabricatorData.id) : -1;
      if(checkAllFeatures) {
        if(index < 0) {
          features.push(p.fabricatorData.id);
        }
      } else {
        if(index >= 0) {
          features.splice(index, 1);
        }
      }
    });
    this.setState({checkAllFeatures, features}, this.forceUpdate);
  }

  hideFilterPopup = () => {
    this.setState({colorFilterOptionsVisible: false, materialFilterOptionsVisible: false, allFilterOptionsVisible: false, sortOptionsVisible: false});
  }

  hasVisualizer = (visualizer) => {
    return this.state.forVisualizers.split(',').indexOf(visualizer) >= 0;
  };

  toggleVisualizer = (visualizer) => {
    let visualizers = this.state.forVisualizers.split(',');
    let index = visualizers.indexOf(visualizer);
    if(index >= 0) {
      visualizers.splice(index, 1);
    } else {
      visualizers.push(_.trim(visualizer));
    }
    this.setState({forVisualizers: visualizers.filter(v => v).join(',')});
  };

  isFeatureSelected = (feature) => {
    return this.state.features.indexOf(feature) >= 0;
  };

  toggleFeature = (feature) => {
    let features = this.state.features;
    let index = features.indexOf(feature);
    if(index >= 0) {
      features.splice(index, 1);
    } else {
      features.push(feature);
    }
    //checkbox visible state doesn't update without forceUpdate
    this.setState({features: [...features]});
  };

  cleanProductName = (feature) => {
    return _.trim(feature.name.substring(this.state.activeGroup.name.length + 2));
  };

  addNewUnit = (text) => {
    let newUnit = {
      id: 0,
      unit: text,
      tempId: uuid.v4()
    };
    let units = this.state.unitList;
    units.push({text: newUnit.unit, value: newUnit});
    let newUnits = this.state.newUnits || [];
    newUnits.push(newUnit);
    this.setState({unit: newUnit, unitList: units, newUnits, showUnitDDL: false});
  }

  onDrop = (file) => {
    this.props.showLoadingDialog(true, "Loading Image...", "Scanning/Loading image, this should only take a moment...")
      .then(() => {
        this.props.showLoadingDialog(false);
        var img = new Image();
        img.onload = () => {
          var height = img.height;
          var width = img.width;
          var warnings = [], errors = [];
          if(height - width !== 0) {
            warnings.push('Image height and width are not equal.  Stone images work best if they are square.');
          }
          if(height > 3840 || width > 3840) {
            warnings.push('Image dimensions are exceeding 3840 pixels in either height or width');
          }
          if(file[0].size > 262144) {
            warnings.push('Image size is exceeding 256kb in size.');
          }
          else if(file[0].size > 4194304) {
            errors.push('Image size is exceeding 4MB in size.');
          }
          if(errors.length > 0) {
            this.props.showErrorBox('Unable to use Image', errors.join('<br />'));
          } else {
            var f = new FileReader();
            f.onload = (e) => this.setState({thumbnailImageUrl: e.target.result, thumbnailImage: file[0]});
            f.readAsDataURL(file[0]);
          }
        }
        if(file && file.length >= 1 && file[0].preview) {
          img.src = file[0].preview;
        } else {
          this.props.showErrorBox("Unable to use Image", "Unrecognized image format, please use a JPEG or PNG image.");
        }
      });
  }

  applyProductSort = (products) => {
    var _products = null;
    if(this.state.productSortBy === PRODUCT_SORT_OPTIONS.Name) {
      _products = _.sortBy(products, a => _.trim(a.name.toLowerCase()));
    } else if(this.state.productSortBy === PRODUCT_SORT_OPTIONS.Price) {
      _products = _.sortBy(products, [a => {
        if(a.fabricatorData)
          return a.fabricatorData.cost;
        return 0;
      }, a => _.trim(a.name.toLowerCase())]);
    }
    return _products;
  }

  applyProductFilters = (products) => {
    var searchFilter = _.trim(this.state.productFilter.toLowerCase());
    var _products = [];
    if(products && products.length > 0) {
      _products = products.filter(p => this.cleanProductName(p).toLowerCase().includes(searchFilter));
    }

    if(this.state.selectedFilters.length > 0) {
      _products = _products.filter(p => {
        var filterIds = _.map(p.filters, f => f.filterGroupValue_id);
        for(var i = 0; i < this.state.selectedFilters.length; i++) {
          if(filterIds.indexOf(this.state.selectedFilters[i]) < 0) {
            return false;
          }
        }
        return true;
      });
    }

    return _products;
  }

  refreshFilterIcons = () => this.setState({materialFilterOptions: this.getMaterialFilterOptions(),
    colorFilterOptions: this.getColorFilterOptions(),
    allFilterOptions: this.getAllFilterOptions(),
    selectedFilters: [],
    expandedFilters: [],
    colorFilterOptionsVisible: false,
    materialFilterOptionsVisible: false,
    allFilterOptionsVisible: false,
    sortOptionsVisible: false,
    checkAllFeatures: false});

  getMaterialFilterOptions = () => this.getFilterOptions('Material');

  getColorFilterOptions = () => this.getFilterOptions("Color");

  getFilterOptions = (filterName) => {
    if(!this.state.activeGroup)
      return [];

    const filterGroups = this.props.filterGroups;
    let products = this.state.activeGroup.features
      , mfgs = filterGroups.filter(fg => fg.name.toLowerCase().includes(filterName.toLowerCase()));

    if(!products || !products.length)
      return [];

    let inUseFilters = this.getInUseFilters(mfgs, products);

    return _.uniqBy(inUseFilters, f => f.id);
  }

  getInUseFilters = (mfgs, products) => {
    let inUseFilters = [];
    mfgs.forEach(mfg => {
      products.forEach(p => {
        if(p.filters && p.filters.length > 0) {
          p.filters.forEach(f => {
            let filterValue = _.find(mfg.values, v => v.id === f.filterGroupValue_id);
            if(filterValue && inUseFilters.indexOf(filterValue) < 0) {
              inUseFilters.push(filterValue);
              return;
            }
            mfg.values.forEach(v => {
              let index = _.findIndex(v.items, i => i.id === f.filterGroupValue_id);
              if(index >= 0) {
                let item = v.items[index];
                let exMfg = _.find(inUseFilters, iuf => iuf.id == mfg.id);
                if(!exMfg) {
                  inUseFilters.push(v);
                  exMfg = mfg;
                }
                exMfg.items = exMfg.items || [];
                if(exMfg.items.indexOf(item) < 0)
                  exMfg.items.push(item);
              }
            })
          });
        }
      });
    });
    return inUseFilters;
  }

  getAllFilterOptions = () => {
    if(!this.state.activeGroup)
    return [];

    const filterGroups = this.props.filterGroups;
    let inUseFilters = []
      , products = this.state.activeGroup.features
      , mfgs = filterGroups.filter(fg => !fg.name.toLowerCase().includes('material') && !fg.name.toLowerCase().includes('color'));

    var topList = [];
    inUseFilters = this.getInUseFilters(mfgs, products);

    let uniqueFilters = _.uniqBy(inUseFilters, f => f.id);

    mfgs.forEach(mfg => {
      let values = mfg.values.filter(v => _.map(uniqueFilters, u => u.id).indexOf(v.id) >= 0);
      if(values.length > 0) {
        topList.push({
          id: mfg.id,
          displayText: mfg.name,
          items: values
        });
      }
    });
    return topList;
  }

  toggleFilter = (id) => {
    let selectedFilters = this.state.selectedFilters;
    let index = selectedFilters.indexOf(id);
    if(index >= 0) {
      selectedFilters.splice(index, 1)
    } else {
      selectedFilters.push(id);
    }
    this.setState({selectedFilters}, this.forceUpdate);
  };

  toggleExpand = (id) => {
    let expandedFilters = this.state.expandedFilters;
    let index = expandedFilters.indexOf(id);
    if(index >= 0) {
      expandedFilters.splice(index, 1)
    } else {
      expandedFilters.push(id);
    }
    this.setState({expandedFilters}, this.forceUpdate);
  };

  handleCancel = () => {
    this.props.showNewInstallationGroupItemOverlay(false);
  }

  handleSave = () => {
    let errors = {
      name: null,
      desc: null,
      thumb: null
    }
    if(_.trim(this.state.name).length == 0) {
      errors.name = "Please enter an Installation Name";
    }
    if(_.trim(this.state.description).length == 0) {
      errors.desc = "Please enter a Description";
    }
    if(_.trim(this.state.thumbnailImageUrl).length == 0) {
      errors.thumb = "Please upload a Thumbnail Image";
    }

    if(!errors.name && !errors.desc && !errors.thumb) {
      var installationData = {
        id: this.state.id,
        installationGroupId: this.state.installationGroup.id,
        name: this.state.name,
        description: this.state.description,
        forQuotingTool: this.state.forQuotingTool,
        forVisualizers: this.state.forVisualizers,
        hideUnitLabel: this.state.hideUnitLabel,
        automaticAdd: this.state.automaticAdd,
        customerAdd: this.state.customerAdd,
        employeeOnly: this.state.employeeOnly,
        hideQuantity: this.state.hideQuantity,
        defaultQuantity: this.state.defaultQuantity,
        assignedFeatures: this.state.features,
        unit: this.state.unit.id,
        newUnits: this.state.newUnits,
        selectedUnitTempId: this.state.unit.tempId,
        thumbnailImageName: this.state.thumbnailImage && this.state.thumbnailImage.name,
        thumbnailImageUrl: this.state.thumbnailImageUrl,
        galleryEnabled: this.state.galleryEnabled,
        galleryImages: this.state.galleryImages
      };
      this.props.save(installationData);
      this.handleCancel();
    } else {
      this.setState({nameError: errors.name, descError: errors.desc, thumbError: errors.thumb});
    }
  }

  handleSetFeatured = (image) => {
    let galleryImages = this.state.galleryImages;
    let index = galleryImages.indexOf(image);
    galleryImages[index].featured = !galleryImages[index].featured;
    this.setState({galleryImages}, this.forceUpdate);
  }

  onGalleryDrop = (files) => {
    this.props.showLoadingDialog(true, "Loading Image...", "Scanning/Loading image, this should only take a moment...")
      .then(() => {
        this.props.showLoadingDialog(false);
        let galleryImages = this.state.galleryImages || [];
        files.forEach(file => {
          let img = new Image();
          img.onload = () => {
            let errors = [];
            if(file.size > 4194304) {
              errors.push('Image ' + file.name + ' size is exceeding 4MB in size.');
            }
            if(errors.length > 0) {
              this.props.showErrorBox('Unable to use Image', errors.join('<br />'));
            } else {
              var f = new FileReader();
              f.onload = (e) => {
                galleryImages.push({
                  id: 0,
                  name: file.name,
                  url: e.target.result,
                  default: false,
                  featured: false
                })
                this.setState({galleryImages}, this.forceUpdate);
              };
              f.readAsDataURL(file);
            }
          }
          if(file && file.preview) {
            img.src = file.preview;
          } else {
            this.props.showErrorBox("Unable to use Image " + file.name, "Unrecognized image format, please use a JPEG or PNG image.");
          }
        });
      });
  }

  getGroupsFeatures = (group) => {
    if(group && group.features && group.features.length > 0) {
      return group.features.filter(f => f.fabricatorData && f.enabled && f.fabricatorData.enabled);
    }
    return [];
  }

  handleMakeDefault = (image) => {
    let galleryImages = this.state.galleryImages;
    galleryImages.forEach(i => i.default = false);
    galleryImages[galleryImages.indexOf(image)].default = true;
    this.setState({galleryImages}, this.forceUpdate);
  }

  handleDeleteGalleryImage = (image) => {
    let galleryImages = this.state.galleryImages;
    galleryImages.splice(galleryImages.indexOf(image), 1);
    this.setState({galleryImages}, this.forceUpdate);
  }

  render = template;
}

NewInstallationOverlayClass.propTypes = {
  installationGroup: PropTypes.object.isRequired
}

const connector = connect(MapStateToProps, MapDispatchToProps);
const NewInstallationOverlay = connector(NewInstallationOverlayClass);

export { NewInstallationOverlay };
export default NewInstallationOverlay;

